module.exports = __webpack_public_path__ + "static/media/07.Stage Set up.056d458f.JPG";